import { axiosInstance } from '.'
import { removeEmptyValueFromObject } from '../lib/utils/helpers'
import { SEARCH_ORDERS_V1 } from './endpoints'

export const orderServices = {
  getOrders: async (params: any) => {
    try {
      const data = await axiosInstance.get(`${SEARCH_ORDERS_V1}`, {
        params: removeEmptyValueFromObject({ ...params }),
      })
      const orders = {
        orders: data.data.orders,
        pagination: {
          count: data.data.count,
          limit: data.data.limit,
          offset: data.data.offset,
          total: data.data.total,
        },
        status: data.status,
      }

      return orders
    } catch (error: any) {
      return error.response
    }
  },
}
